import React from 'react';
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import Agreement from './containers/Agreement';
import Agreement2 from './containers/Agreement2';
import Form from './containers/Form';
import { getPropsFromObject } from "./utils";

dayjs.extend(isSameOrAfter);

const App = props => {
  const { agreement } = props;
  const { Invoicedate } = getPropsFromObject("Invoicedate")(agreement);
  return (
    <React.StrictMode>
      {/* {!agreement
      ? <Form />
      : <Agreement agreement={agreement} />} */}
      
      {agreement && (
        dayjs(Invoicedate).isSameOrAfter(dayjs("2025-07-02"), "day") ? (
          <Agreement2 agreement={agreement} />
        ) : (
          <Agreement agreement={agreement} />
        )
      )}
    </React.StrictMode>
  );
};

export default App;
